/*
 * Public API Surface of angular-qrious-lib
 */

export * from './lib/qr-code.component';
export * from './lib/qrious.module';
